module.exports = __webpack_public_path__ + "img/词库统计.da4d8837.svg";